import React, { useState } from 'react';
import propTypes from 'prop-types';
;
import classNames from 'classnames';
import { SaveChangesToast, ConfirmChangesModal } from 'src/ui';
import { LoanFinancialsForm } from './LoanFinancialsForm';
import { LoanCreditRequestForm } from './LoanCreditRequestForm';
import { LoanDeclarationsNotificationsForm } from './LoanDeclarationsNotificationsForm';
import { LoanSummaryForm } from './LoanSummaryForm';
import { Tabs, TabList, Tab, TabLink } from 'src/ui/mui-ui-kit'

export function LoanEditForm({
  onSubmit,
  submitting,
  hasValidationErrors,
  isDirty,
  isExpanded,
  ...props
}) {
  const [confirmChangesModal, setConfirmChangesModal] = useState(false);
  const toastContainerClassName = classNames('bottom-toast-container', {
    'is-condensed': !isExpanded,
  });
  const user = { ...props.user };
  const tabs = [...props.tabs];
  // eslint-disable-next-line prefer-destructuring
  const activeTab = props.activeTab;
  // eslint-disable-next-line prefer-destructuring
  const setActiveTab = props.setActiveTab;

  function showModal() {
    setConfirmChangesModal(true);
  }
  function hideModal() {
    setConfirmChangesModal(false);
  }

  return (
    <>
      <form onSubmit={onSubmit} noValidate>
        <div className={toastContainerClassName}>
          <SaveChangesToast
            message="Click the button to the right to save your changes"
            isLoading={submitting}
            isDisabled={submitting || hasValidationErrors}
            isVisible={isDirty}
            // eslint-disable-next-line react/jsx-no-bind
            onClickButton={showModal}
          />
        </div>
        <ConfirmChangesModal
          title="Loan"
          isActive={confirmChangesModal}
          // eslint-disable-next-line react/jsx-no-bind
          onClickCancel={hideModal}
          // eslint-disable-next-line react/jsx-no-bind
          onClickSubmit={hideModal}
        />
        <Tabs isToggle>
          <TabList>
            {tabs.map(tab => {
              let result;
              if (
                tab.permission === 'user' ||
                (tab.permission === 'bankAdmin' && user.isBankAdmin)
              ) {
                result = (
                  <Tab isActive={activeTab === tab.id} key={tab.id}>
                    <TabLink onClick={() => setActiveTab(tab.id)}>
                      {tab.label}
                    </TabLink>
                  </Tab>
                );
              }
              return result;
            })}
          </TabList>
        </Tabs>
        {tabs.map(tab => {
          const TabComponent = tab.component;
          const className = tab.id === activeTab ? '' : 'is-hidden';

          return <TabComponent {...props} className={className} key={tab.id} />;
        })}
      </form>
    </>
  );
}

LoanEditForm.propTypes = {
  onSubmit: propTypes.func.isRequired,
  submitting: propTypes.bool.isRequired,
  hasValidationErrors: propTypes.bool.isRequired,
  isDirty: propTypes.bool.isRequired,
  isExpanded: propTypes.bool.isRequired,
  activeTab: propTypes.string.isRequired,
  setActiveTab: propTypes.func.isRequired,
  tabs: propTypes.array.isRequired,
  ...LoanFinancialsForm.propTypes,
  ...LoanCreditRequestForm.propTypes,
  ...LoanDeclarationsNotificationsForm.propTypes,
  ...LoanSummaryForm.propTypes,
};
